/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Heading,
  Button,
  TextField,
  Dialog,
  Divider,
  Content,
  Form,
  ButtonGroup,
  useDialogContainer,
} from '@adobe/react-spectrum';
import PropTypes from 'prop-types';

function RenameDialog(props) {
  const { boardName, setCurrentText, renameUserBoards, state } = props;
  const dialogButton = useDialogContainer();

  return (
    <Dialog>
      <Heading>Edit Board Name</Heading>
      <Divider />
      <Content>
        <Form>
          <TextField
            aria-label="textfield"
            placeholder="Board Name"
            width="550px"
            onChange={setCurrentText}
            defaultValue={boardName}
          />
          <ButtonGroup>
            <Button variant="secondary" onPress={dialogButton.dismiss}>
              Cancel
            </Button>
            <Button
              UNSAFE_className="dropdown-item"
              onPress={() => {
                renameUserBoards(state.currentText, boardName);
                dialogButton.dismiss();
              }}
            >
              Rename Board
            </Button>
          </ButtonGroup>
        </Form>
      </Content>
    </Dialog>
  );
}

RenameDialog.propTypes = {
  boardName: PropTypes.string,
  setCurrentText: PropTypes.func,
  renameUserBoards: PropTypes.func,
  state: PropTypes.object,
};

RenameDialog.defaultProps = {
  boardName: '',
  setCurrentText: () => {},
  renameUserBoards: () => {},
  state: {},
};

export default RenameDialog;
